import { api_configuration } from "../../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { iNode } from "../../state/Node";

export function entity(client_state: api_cs.Cnode): void {
	if (client_state.destroyed) return;
	client_state.properties.modified.switch({
		yes: function () {
			client_state.properties.is_busy_discarding.set("yes", {});
			iNode(client_state).discard();
			client_state.properties.is_busy_discarding.set("no", {});
		},
		no: undefined,
	});
}

export function isBusyDiscarding(node: api_cs.Cnode): boolean {
	switch (node.properties.is_busy_discarding.state.name) {
		case "yes":
			return true;
		case "no": {
			const entity = node.input.entity().variant;
			switch (entity.name) {
				case "root":
					return false;
				case "entry":
					return isBusyDiscarding(entity.definition.component_root);
			}
		}
	}
}
